import Header from "./components/Header"
import Footer from "./components/Footer"
import JsonFormatter from "./components/JsonFormatter"

function App() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <JsonFormatter />
      </main>
      <Footer />
    </div>
  )
}

export default App
